(() => {
  document.documentElement.classList.add('nii-js');

  document.querySelectorAll('.nii-product-form select[name^="options"]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (!form) return;
      form.dispatchEvent(new CustomEvent('nii:variant-options-change', { bubbles: true }));
    });
  });
})();
